import { YMAL_SET, YMAL_SET_DATA } from '../actionConstants';
import { Ymal } from './ymalTypes';
import { Action } from '../../generalTypes';
import defaultState from './ymalDefaultState';

export default (state: Ymal = defaultState, action: Action<any>): Ymal => {
  switch (action.type) {
    case YMAL_SET:
      const { articleGroups, articles } = action.payload;
      return {
        ...state,
        articleGroups,
        articles,
      };

    case YMAL_SET_DATA:
      return {
        ...state,
        ymal: action.payload.ymals,
      };

    default:
      return state;
  }
};
